import React from "react";
import classes from "../components/Footer.module.css";
import "font-awesome/css/font-awesome.min.css";
import SocialLinks from "./SocialLinks";
export default function Footer() {
  return (
    <div className="">
      <div className={classes.footer}>
        <div className="row text-center">
          <div className="col-lg-12 col-sm-12 col-xs-12">
            <div className={classes.footer_menu}>
              <ul>
                <li>
                  <a href="#">Home</a>
                </li>
                <li>
                  <a href="#">About</a>
                </li>
                {/* <li>
                  <a href="#">Service</a>
                </li>
                <li>
                  <a href="#">Works</a>
                </li> */}
                <li>
                  <a href="#">Contact</a>
                </li>
              </ul>
            </div>
            <SocialLinks />
            <div className="footer_copyright">
              <p>© 2024 All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
